import axios from "axios";
import { setAlert } from "./alert";

import {
  ADD_QUESTIONS,
  ADD_QUESTIONS_ERROR,
  GET_QUESTIONS,
  GET_QUESTIONS_ERROR,
  GET_QUESTION,
  GET_QUESTION_ERROR,
  DELETE_QUESTION,
  DELETE_QUESTION_ERROR,
  GET_QUESTIONS_PAGE,
} from "./types";

// Get all universities
export const dashboard = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/questions/dashboard"
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};
// Get all universities
export const adminDashboard = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/questions/admin-dashboard"
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};
export const getQuestions = () => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + "/v2/questions"
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const getCurrentQuestionDetail = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/questions/view-detailed-question/${id}`
    );

    dispatch({
      type: GET_QUESTION,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_QUESTION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

// Get all universities
export const getCurrentQuestion = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/questions/${id}`
    );

    dispatch({
      type: GET_QUESTION,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    dispatch({
      type: GET_QUESTION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};
export const getQuestionPagination = (pageNo) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/questions/pagination/${pageNo}`
    );

    dispatch({
      type: GET_QUESTIONS_PAGE,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const getCategoryQuestion = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/questions/category/${id}`
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const getQuestionTypeQuestion = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/questions/question_type/${id}`
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const getSubcategoryQuestion = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL + `/v2/questions/subcategory/${id}`
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
export const getSubtopicQuestion = (id, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/questions/admin-subtopics/${id}/${page}`
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
export const getSubtopicQuestionAdmin = (id, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/questions/admin-subtopics-questions/${id}/${page}`
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
export const getSubtopicQuestionSubadmin = (id, page) => async (dispatch) => {
  try {
    const res = await axios.get(
      process.env.REACT_APP_SITE_URL +
        `/v2/questions/subadmin-subtopics/${id}/${page}`
    );

    dispatch({
      type: GET_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: GET_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
export const getCategoryQuestionPagination =
  (id, pageNo) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/questions/category/pagination/${id}/${pageNo}`
      );

      dispatch({
        type: GET_QUESTIONS_PAGE,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch({
        type: GET_QUESTIONS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

export const getQuestionTypeQuestionPagination =
  (id, pageNo) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/questions/question_type/pagination/${id}/${pageNo}`
      );

      dispatch({
        type: GET_QUESTIONS_PAGE,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch({
        type: GET_QUESTIONS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

export const getSubcategoryQuestionPagination =
  (id, pageNo) => async (dispatch) => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_SITE_URL +
          `/v2/questions/subcategory/pagination/${id}/${pageNo}`
      );

      dispatch({
        type: GET_QUESTIONS_PAGE,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      dispatch({
        type: GET_QUESTIONS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

export const addQuestion = (record) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + "/v2/questions",
      record,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};
export const editQuestion = (id, record) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/questions/${id}`,
      record,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const migrateQuestions = (from_id, record) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL +
        `/v2/questions/migrate_user_data/${from_id}`,
      record,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const sleepQuestion = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/questions/sleep/${id}`,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const sleepCategory = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/questions/sleep_category/${id}`,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const sleepSubcategory = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.put(
      process.env.REACT_APP_SITE_URL + `/v2/questions/sleep_subcategory/${id}`,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const addQuestionFile = (id, formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/questions/${id}`,
      formData,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};
export const addQuestionImages =
  (id, metakey, formData) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const res = await axios.post(
        process.env.REACT_APP_SITE_URL + `/v2/questions/image/${id}/${metakey}`,
        formData,
        config
      );
      dispatch({
        type: ADD_QUESTIONS,
        payload: res.data,
      });
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
      }

      dispatch({
        type: ADD_QUESTIONS_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
      return errors;
    }
  };
export const sleepSelected = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/questions/sleep_partial/update`,
      formData,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};
export const updateSelected = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL +
        `/v2/questions/category_subcatgory/update`,
      formData,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const uploadCSV = (formData) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const res = await axios.post(
      process.env.REACT_APP_SITE_URL + `/v2/questions/upload_file`,
      formData,
      config
    );
    dispatch({
      type: ADD_QUESTIONS,
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: ADD_QUESTIONS_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
    return errors;
  }
};

export const deleteQuestion = (Id) => async (dispatch) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL +
        process.env.REACT_APP_SITE_URL +
        `/v2/questions/${Id}`
    );
    dispatch({
      type: DELETE_QUESTION,
      payload: res.data,
    });

    dispatch(setAlert("Record has been removed", "success"));
  } catch (err) {
    dispatch({
      type: DELETE_QUESTION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const deleteAllQuestion = () => async (dispatch) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL + `/v2/questions`
    );
    dispatch({
      type: DELETE_QUESTION,
      payload: res.data,
    });

    dispatch(setAlert("Record has been removed", "success"));
  } catch (err) {
    dispatch({
      type: DELETE_QUESTION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const deleteQuestionType = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(
      process.env.REACT_APP_SITE_URL +
        process.env.REACT_APP_SITE_URL +
        `/v2/questions/question_type/${id}`
    );
    dispatch({
      type: DELETE_QUESTION,
      payload: res.data,
    });

    dispatch(setAlert("Record has been removed", "success"));
  } catch (err) {
    dispatch({
      type: DELETE_QUESTION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
